// Generated by Melange

import * as CamlinternalAtomic from "./camlinternalAtomic.js";

const make = CamlinternalAtomic.make;

const get = CamlinternalAtomic.get;

const set = CamlinternalAtomic.set;

const exchange = CamlinternalAtomic.exchange;

const compare_and_set = CamlinternalAtomic.compare_and_set;

const fetch_and_add = CamlinternalAtomic.fetch_and_add;

const incr = CamlinternalAtomic.incr;

const decr = CamlinternalAtomic.decr;

export {
  make,
  get,
  set,
  exchange,
  compare_and_set,
  fetch_and_add,
  incr,
  decr,
}
/* No side effect */
